import { render, staticRenderFns } from "./WorkspaceCreateDialog.vue?vue&type=template&id=4a74859d&"
import script from "./WorkspaceCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceCreateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceCreateDialog.vue?vue&type=style&index=0&id=4a74859d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports